'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@pc/components/ui/dropdown-menu';
import { Skeleton } from '@pc/components/ui/skeleton';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import NavMenuList from './_components/nav-menu-list/NavMenuList';
const NavMenuButton = dynamic(() => import('@pc/components/atoms/button/topbar/NavMenuButton'), {
  ssr: false,
  loading: () => <Skeleton className='mr-2 h-[28px] w-[28px]' />
});
function MyNavMenuSSGContainer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DropdownMenu modal={false}><Suspense fallback={<Skeleton className="mr-2 h-[28px] w-[28px]" />}><NavMenuButton /></Suspense><NavMenuList /></DropdownMenu>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default MyNavMenuSSGContainer;